import styled from 'styled-components';

export default styled.div`
  margin-top: 1rem;
  font-weight: 700;
`;
